import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { WorkingDocumentModel } from "models/WorkingDocumentModel";
import { createContext } from "react";

export interface DocumentContextProps {
  documents: WorkingDocumentModel[] | undefined;
  setDocuments: (documents: WorkingDocumentModel[] | undefined) => void;
  selectDocumentId: number;
  setSelectDocumentId: (id: number) => void;
  confirmDeleteDocument: ConfirmDeleteTarget | undefined;
  setConfirmDeleteDocument: (target: ConfirmDeleteTarget | undefined) => void;
  editDocumentId: number;
  setEditDocumentId: (id: number) => void;
  uploadFileAgendaItemId: number;
  setUploadFileAgendaItemId: (id: number) => void;
  uploadingAgendaItemId: number;
  isUploading: boolean;
  onFileChanged: (file: File) => void;
  isDocumentDeleting: (id: number) => boolean;
  setDocumentDeleting: (id: number, newState: boolean) => void;
  isDocumentUpdating: (id: number) => boolean;
  setDocumentUpdating: (id: number, newState: boolean) => void;
}

export const DocumentContext = createContext({} as DocumentContextProps);
